<template>
	<section class="view-venue-comments padded alternate-panel">
		<ViewLayoutModuleHeader title="Start some drama">
			<a href="#" v-on:click="Handle_OnClickSeeAllComments">View All</a>
		</ViewLayoutModuleHeader>

		<!-- List of comments (no replies, max 4)-->
		<section class="pad-left" v-if="venueModel.comments.length > 0">
			<ChalkyCommentList
				class="truncated-list"
				direction="asc"
				maxHeight="70svh"
				v-bind:canReact="false"
				v-bind:model="venueModel"
				v-bind:showCommentForm="false"
				v-on:user:click="Handle_OnClickUser"
			/>

			<section class="text-center push-top-lg padded">
				<button class="button-primary size-small" v-on:click="Handle_OnClickSeeAllComments">See More</button>
			</section>
		</section>

		<!-- Call to action to comment-->
		<section v-else class="callout-container">
			<ViewUiCalloutMedia
				action="Post a Comment"
				subtitle="Be the first to drop a comment. Ask a question, share a tip, or just talk trash."
				title="Speak up!"
				v-bind:imageUrl="$asset('image/graphic/empty-table-01.webp')"
				v-bind:venueModel="venueModel"
				v-on:action="Handle_OnClickAction"
			/>
		</section>

		<ChalkyUtilityModal
			class="default-modal"
			v-model="isCommentModalVisible"
			v-bind:closeOnBackdropClick="true"
			v-bind:closeOnEscape="true"
			v-bind:showCloseButton="true"
		>
			<ChalkyCommentList
				direction="asc"
				v-bind:canReact="false"
				v-bind:key="venueModel.uniqueKey"
				v-bind:model="venueModel"
				v-on:user:click="Handle_OnClickUser"
			/>
		</ChalkyUtilityModal>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueComments extends ViewBase {
		/**
		 * Whether the comment modal is visible
		 *
		 * @type boolean
		 */
		protected isCommentModalVisible: boolean = false;

		/**
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @return Promise<void>
		 */
		protected async Handle_OnClickAction(): Promise<void> {
			this.isCommentModalVisible = true;
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickSeeAllComments(e: PointerEvent): Promise<void> {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			this.isCommentModalVisible = true;
		}

		/**
		 * @param PointerEvent e
		 * @param ChalkySticks.Model.User userModel
		 * @return Promise<void>
		 */
		protected async Handle_OnClickUser(e: PointerEvent, userModel: ChalkySticks.Model.User): Promise<void> {
			e.preventDefault();

			this.$store.dispatch('gotoUser', userModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-comments {
		.callout-container {
			background: var(--chalky-blue-4);
			border-radius: 1rem;
			display: block;
			height: 100%;
			padding: 2rem 1rem 1rem 1rem;
			position: relative;
			width: 100%;
		}

		.utility-modal.default-modal .modal-content {
			overflow: hidden;
			padding: 0;

			.chalky.comment-list {
				height: 100%;
				margin: 0;
				overflow: auto;
				padding: 1rem;

				.comment-container {
					flex: 1;
				}
			}
		}

		// only show last three comments in list
		.chalky.comment-list.truncated-list {
			header {
				display: none;
			}

			.comment-container {
				padding-top: 0;
				position: relative;

				.comment-item {
					&:nth-child(n + 5) {
						display: none;
					}

					// maintains vertical height
					.actions {
						display: none;
						opacity: 0;
						pointer-events: none;
					}

					.replies {
						display: none;
					}
				}
			}
		}
	}

	// Animation
	// ---------------------------------------------------------------------------

	.view-venue-comments {
		.utility-modal.state-visible .comment-list {
			animation: slide-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;

			@keyframes slide-top {
				0% {
					opacity: 0;
					transform: translateY(50px);
				}

				100% {
					opacity: 1;
					transform: translateY(0px);
				}
			}
		}
	}
</style>
